//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"DoubleDefault",1,0],[0,"DoubleMax",1,0],[0,"DoubleMin",1,0],[0,"IntegerDefault",1,0],[0,"IntegerMax",1,0],[0,"IntegerMin",1,0],[0,"NoteText",1,0],[0,"NoteTitle",1,0],[0,"Rule",1,0],[0,"TextType",1,0]],[[["nMultilineString"],"GetMultilineString",{R_:{multilineString:""}},0,0],[["multilineString"],"SetMultilineString",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.MasterSymbolListItemBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.MasterSymbolListItemBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.MasterSymbolListItemBuilder.TextTypes = Object.freeze({
    "Mandatory" : "Mandatory", "Arbitrary" : "Arbitrary", "Controlled" : "Controlled", "PartiallyControlled" : "PartiallyControlled", "Integer" : "Integer", "Real" : "Real", "Rule" : "Rule"});

export default SPLM;